import DialCodeList from '../constants/lists';

export const getTextFromPotentialHtmlString = (value) => {
  // If it looks like a html string, try to use the element text instead
  if (value?.indexOf('<') === 0) {
    const template = document.createElement('template');
    template.innerHTML = value;
    const elem = template?.content?.firstElementChild as any;
    return elem?.innerText || value || '';
  }
  return value || '';
};

export const formatCountryOptions = (countries, descriptionAsValue?: boolean) => {
  if (!countries) return [];
  const formatted = countries?.map((c) => ({
    name: c.description || '',
    value: descriptionAsValue ? c.description || '' : c.code || '',
  }));
  const norwayIndex = formatted?.findIndex((country) => country.value === 'NOR');
  const norway = formatted.splice(norwayIndex, 1);
  const sortedCountries =
    formatted?.sort((a, b) => (a.name || '').localeCompare(b.name || '')) || [];
  return norway?.concat(sortedCountries);
};

export const splitPhoneNumber = (
  phone: string
): { dialCode: null | string; phoneNumber: string } => {
  if (!phone) {
    return { dialCode: null, phoneNumber: '' };
  }
  const onlyDigits = phone.replace(/^\+/, '');
  const sortedDialCodes = [...DialCodeList].sort(
    (a, b) => (b?.value as string).length - (a?.value as string).length
  );
  const match = sortedDialCodes.find((c) => onlyDigits.startsWith(c.value as string));
  if (!match) {
    return { dialCode: null, phoneNumber: onlyDigits };
  }
  return {
    dialCode: match.value as string,
    phoneNumber: onlyDigits.slice((match?.value as string).length),
  };
};
